<template>
  <section>
    <span>Attachments</span>
    <div class="row">
      <div class="col"></div>
    </div>
    <div v-if="isAuthor" class="row">
      <div class="col">
        <file-pond
          ref="pond"
          name="test"
          :server="{ process, revert, restore, load, fetch }"
          label-idle="Drop a file here..."
          allow-multiple="true"
          allow-revert="false"
          accepted-file-types="image/bmp, image/jpeg, image/png, image/gif, text/csv, audio/mpeg, video/mpeg, application/pdf, application/rtf, text/plain, application/zip, application/vnd.ms-excel, application/vnd.ms-powerpoint, application/msword"
          :files="uploadFiles"
          @init="handleFilePondInit"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <ul class="custom-file-list">
          <li v-for="item of attachments" :key="item.blogAttachment">
            <div class="row custom-file-record">
              <div class="col-1">
                <a :href="item.fileUrl" target="_blank">link</a>
              </div>
              <div class="col-10">
                <span>{{ item.filename }}</span>
              </div>
              <div v-if="isAuthor" class="col-1 custom-file-remove">
                <a href="#" class="custom-remove" tabindex="-1" @click="removeAttachment(item)">
                  <i class="fas fa-times text-danger"></i>
                </a>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="row">
      <div class="col"></div>
    </div>
  </section>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { blogStore } from '@/stores/blog'
import axios from 'axios'
import vueFilePond from 'vue-filepond'
import 'filepond/dist/filepond.css'
const FilePond = vueFilePond()
export default {
  name: 'BlogAttachment',
  components: {
    FilePond
  },
  data() {
    return {
      uploadFiles: [],
      apiUrl: '',
      imageUrl: null,
      firm: null,
      path: null
    }
  },
  mounted() {
    this.apiUrl = window.config ? window.config.apiUrl : ''
    this.init()
  },
  computed: {
    ...mapState(authStore, ['profile', 'token']),
    ...mapState(blogStore, ['blog', 'attachments']),
    isAuthor() {
      let _is = false
      if (this.blog) {
        if (this.profile) {
          if (parseInt(this.blog.createdBy) === parseInt(this.profile.user)) {
            _is = true
          }
        }
      }
      return _is
    }
  },
  methods: {
    ...mapActions(blogStore, ['deleteAttachment', 'getAttachments']),
    async init() {
      let elements = document.getElementsByClassName('filepond--credits')
      if (elements) {
        if (elements.length > 0) {
          elements[0].style['display'] = 'none'
        }
      }
      await this.getAttachments({
        blog: this.blog.blog,
        blogComment: null
      })
    },
    process(fieldName, file, metadata, load, error, progress) {
      let $this = this
      if (this.blog.blog) {
        // set data
        const formData = new FormData()
        formData.append('files', file, file.name)
        formData.append('firm', this.profile.firm)
        formData.append('path', `blogs/${this.profile.firm}/${this.blog.blog}`)
        formData.append('blogComment', null)
        formData.append('blog', this.blog.blog)
        // related to aborting the request
        const CancelToken = axios.CancelToken
        const source = CancelToken.source()
        axios.interceptors.request.use(
          (config) => {
            config.headers['Authorization'] = 'Bearer ' + this.token
            return config
          },
          (error) => {
            return Promise.reject(error)
          }
        )
        // the request itself
        axios({
          method: 'post',
          url: `${this.apiUrl}/blog/uploadFiles`,
          data: formData,
          cancelToken: source.token,
          onUploadProgress: (e) => {
            // updating progress indicator
            progress(e.lengthComputable, e.loaded, e.total)
          }
        })
          .then((response) => {
            let data = {
              filename: file.name,
              url: response.data
            }
            console.log('Successfully uploaded', data)
            load(file.name)
            this.getAttachments({
              blog: this.blog.blog,
              blogComment: null
            })
            $this.$emit('uploaded', data)
          })
          .catch((thrown) => {
            if (axios.isCancel(thrown)) {
              console.log('Request canceled', thrown.message)
            } else {
              // handle error
            }
          })
        // Setup abort interface
        return {
          abort: () => {
            source.cancel('Operation canceled by the user.')
          }
        }
      } else {
        return null
      }
    },
    handleError(error) {
      console.log('Error', error)
    },
    handleFilePondInit: function () {},
    removeAttachment() {}
  }
}
</script>
<style lang="scss" scoped>
.custom-file-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
  padding-left: 15px;
  padding-right: 15px;
}
.custom-file-record {
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>
